import React, { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { authRoutes } from "routes";

// Chakra imports
import { Box, useColorModeValue } from "@chakra-ui/react";

// Layout components
import { SidebarContext } from "contexts/SidebarContext";

export default function AuthLayout() {
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const authBg = useColorModeValue("white", "navy.900");
  document.documentElement.dir = "ltr";

  return (
    <Box>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
        }}
      >
        <Box
          bg={authBg}
          float="right"
          minHeight="100vh"
          height="100%"
          position="relative"
          w="100%"
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          <Box mx="auto" minH="100vh">
            <Routes>
              {authRoutes.map((route, idx) => (
                <Route path={route.path} element={route.element} key={idx} />
              ))}
              {/* 기본 경로: 로그인으로 리다이렉트 */}
              <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
              <Route path="*" element={<Navigate to="/auth/sign-in" replace />} />
            </Routes>
          </Box>
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
